import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { inlineIcon } from 'assets/images';

import styles from './style.module.scss';

function LinkCard({ text, description, buttons = [], defaultLink, headers }) {
  const { t } = useTranslation('global');
  const [selectedButtonLabel, setSelectedButtonLabel] = useState(
    buttons[0]?.label || '',
  );
  const [showCopied, setShowCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(
      buttons.find(button => button.label === selectedButtonLabel)?.link ||
        defaultLink,
    );
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 1000);
  };

  const handleButtonClick = buttonLabel => {
    setSelectedButtonLabel(buttonLabel);
  };

  return (
    <div>
      {buttons.length > 0 && (
        <div>
          <div className={styles.inlineHeader}>
            <p className={styles.titleText}>{text}</p>
            <div className={styles.inlineButton}>
              {buttons
                .sort((a, b) => a.id - b.id)
                .map(button => (
                  <button
                    key={button.label}
                    type="button"
                    className={clsx(
                      selectedButtonLabel === button.label && styles.active,
                      selectedButtonLabel !== button.label && styles.default,
                    )}
                    onClick={() => handleButtonClick(button.label)}>
                    {button.label}
                  </button>
                ))}
            </div>
          </div>
          <div className={styles.urlLink}>
            <img
              aria-hidden="true"
              className={clsx(styles.icon, styles.copyable)}
              src={inlineIcon}
              alt="inline icon"
              onClick={copyToClipboard}
              loading="lazy"
            />
            <div className={styles.links}>
              {buttons.find(button => button.label === selectedButtonLabel)
                ?.link &&
              buttons
                .find(button => button.label === selectedButtonLabel)
                ?.link.includes('\\n') ? (
                buttons
                  .find(button => button.label === selectedButtonLabel)
                  ?.link.split('\\n')
                  .map(line => (
                    <Link
                      key={`line-${line}`}
                      to={line}
                      style={{ textDecoration: 'none' }}
                      target="_blank"
                      rel="noopener noreferrer">
                      <p className={styles.link}>{line}</p>
                    </Link>
                  ))
              ) : (
                <Link
                  to={
                    buttons.find(button => button.label === selectedButtonLabel)
                      ?.link
                  }
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  <p className={styles.link}>
                    {
                      buttons.find(
                        button => button.label === selectedButtonLabel,
                      )?.link
                    }
                  </p>
                </Link>
              )}
              {showCopied && (
                <div className={styles.copiedText}>{t('copied')}</div>
              )}
            </div>
          </div>
        </div>
      )}

      {buttons.length === 0 && (
        <div className={styles.textLink}>
          <p className={styles.text}>
            {text}
            <span className={clsx(headers ? styles.headers : styles.none)}>
              {headers}
            </span>
          </p>
          <p className={styles.descriptionText}>{description}</p>
          <div className={styles.urlLink}>
            <img
              aria-hidden="true"
              className={clsx(styles.icon, styles.copyable)}
              src={inlineIcon}
              alt="inline icon"
              onClick={copyToClipboard}
              loading="lazy"
            />
            <Link
              to={defaultLink}
              style={{ textDecoration: 'none' }}
              target="_blank">
              <p className={styles.link}>{defaultLink}</p>
            </Link>
            {showCopied && (
              <div className={styles.copiedText}>{t('copied')}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default LinkCard;
